// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Person  {
    _originalTypeClassName = "Loom.BO.Person";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Person.translate = translateService;
}
this.EmploymentRelationships = [];
this.ApprovingLeavesFor = [];
this.LeaveRequests = [];
this.BankAccounts = [];
this.LeaderOf = [];
this.MemberOf = [];
this.TeamsCreated = [];
this.OrganisationAffiliations = [];
this.Competencies = [];
this.Id = null;
this.FirstName = null;
this.MiddleName = null;
this.LastName = null;
this.FullName = null;
this.ShortFullName = null;
this.CallName = null;
this.Gender = null;
this.BirthDate = null;
this.VATNumber = null;
this.VATRegOffice = null;
this.SocialSecurityNumber = null;
this.Nationality = null;
this.PhoneNumber = null;
this.MobileNumber = null;
this.Email = null;
this.PersonalEmail = null;
this.Address = null;
this.City = null;
this.PostCode = null;
this.EmployeeStatus = null;
this.Bio = null;
this.WorkExperienceYears = null;
this.ORCID_ID = null;
this.ResearchCareerStage = null;
this.PassportNr = null;
this.NationalId = null;
this.FrequentFlyerNr = null;
this.FrequentFlyerCo = null;
this.MaritalStatus = null;
this.NrOfChildren = null;
this.ShowInGlobalList = false;
this.CreatedOn = null;
this.OrgAffiliationsCaption = null;
this.AccessToProjects = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FirstName:any;
MiddleName:any;
LastName:any;
FullName:any;
ShortFullName:any;
CallName:any;
Gender:any;
BirthDate:any;
VATNumber:any;
VATRegOffice:any;
SocialSecurityNumber:any;
Nationality:any;
PhoneNumber:any;
MobileNumber:any;
Email:any;
PersonalEmail:any;
Address:any;
City:any;
PostCode:any;
EmployeeStatus:any;
Bio:any;
WorkExperienceYears:any;
ORCID_ID:any;
ResearchCareerStage:any;
PassportNr:any;
NationalId:any;
FrequentFlyerNr:any;
FrequentFlyerCo:any;
MaritalStatus:any;
NrOfChildren:any;
ShowInGlobalList:any;
CreatedOn:any;
OrgAffiliationsCaption:any;
AccessToProjects:any;
EmploymentRelationships:any;
ApprovingLeavesFor:any;
LeaveRequests:any;
BasedInCountry:any;
Account:any;
Invitation:any;
EmergencyContact:any;
BankAccounts:any;
Photo:any;
CVFile:any;
LeaderOf:any;
MemberOf:any;
CreatedBy:any;
TeamsCreated:any;
OrganisationAffiliations:any;
Competencies:any;
static setEmploymentRelationships = ($this, items) => {
                if (items == null) items = [];
                if ($this.EmploymentRelationships == null) $this.EmploymentRelationships = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EmploymentRelationships.length > 0) {
                    Domain.Person.removeEmploymentRelationships($this, $this.EmploymentRelationships[0]);
                }

                Domain.Person.addManyEmploymentRelationships($this, copyItems);
            }
static addManyEmploymentRelationships = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addEmploymentRelationships($this, items[i]);
                }
            }
static addEmploymentRelationships = ($this, item) => {
                if ($this.EmploymentRelationships == null) $this.EmploymentRelationships = [];
                if (item == null || $this.EmploymentRelationships.indexOf(item) > -1) return;
                $this.EmploymentRelationships.push(item);
if (item.Person != $this) {
Domain.Employee.setPerson(item, $this);
}
}
static addRangeEmploymentRelationships = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addEmploymentRelationships($this, item));
            }
static removeEmploymentRelationships = ($this, item) => {
                if ($this == null || $this.EmploymentRelationships == null || $this.EmploymentRelationships.indexOf(item) === -1) return;
                var _index = $this.EmploymentRelationships.indexOf(item);
                $this.EmploymentRelationships.splice(_index, 1);
item.Person = null;
}
static clearEmploymentRelationships = ($this) => { $this.EmploymentRelationships = null; }
static setApprovingLeavesFor = ($this, items) => {
                if (items == null) items = [];
                if ($this.ApprovingLeavesFor == null) $this.ApprovingLeavesFor = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ApprovingLeavesFor.length > 0) {
                    Domain.Person.removeApprovingLeavesFor($this, $this.ApprovingLeavesFor[0]);
                }

                Domain.Person.addManyApprovingLeavesFor($this, copyItems);
            }
static addManyApprovingLeavesFor = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addApprovingLeavesFor($this, items[i]);
                }
            }
static addApprovingLeavesFor = ($this, item) => {
                if ($this.ApprovingLeavesFor == null) $this.ApprovingLeavesFor = [];
                if (item == null || $this.ApprovingLeavesFor.indexOf(item) > -1) return;
                $this.ApprovingLeavesFor.push(item);
Domain.Employee.addLeaveApprovers(item, $this);
}
static addRangeApprovingLeavesFor = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addApprovingLeavesFor($this, item));
            }
static removeApprovingLeavesFor = ($this, item) => {
                if ($this == null || $this.ApprovingLeavesFor == null || $this.ApprovingLeavesFor.indexOf(item) === -1) return;
                var _index = $this.ApprovingLeavesFor.indexOf(item);
                $this.ApprovingLeavesFor.splice(_index, 1);
Domain.Employee.removeLeaveApprovers(item, $this);
}
static clearApprovingLeavesFor = ($this) => { $this.ApprovingLeavesFor = null; }
static setLeaveRequests = ($this, items) => {
                if (items == null) items = [];
                if ($this.LeaveRequests == null) $this.LeaveRequests = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LeaveRequests.length > 0) {
                    Domain.Person.removeLeaveRequests($this, $this.LeaveRequests[0]);
                }

                Domain.Person.addManyLeaveRequests($this, copyItems);
            }
static addManyLeaveRequests = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addLeaveRequests($this, items[i]);
                }
            }
static addLeaveRequests = ($this, item) => {
                if ($this.LeaveRequests == null) $this.LeaveRequests = [];
                if (item == null || $this.LeaveRequests.indexOf(item) > -1) return;
                $this.LeaveRequests.push(item);
if (item.Person != $this) {
Domain.LeaveRequest.setPerson(item, $this);
}
}
static addRangeLeaveRequests = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addLeaveRequests($this, item));
            }
static removeLeaveRequests = ($this, item) => {
                if ($this == null || $this.LeaveRequests == null || $this.LeaveRequests.indexOf(item) === -1) return;
                var _index = $this.LeaveRequests.indexOf(item);
                $this.LeaveRequests.splice(_index, 1);
item.Person = null;
}
static clearLeaveRequests = ($this) => { $this.LeaveRequests = null; }
static setBasedInCountry = ($this, value) => {
var oldValue = $this.BasedInCountry;
$this.BasedInCountry = value;
if (value != null) {
}
}
static setAccount = ($this, value) => {
var oldValue = $this.Account;
$this.Account = value;
if (value != null) {
if (oldValue != null && oldValue.Person != null) { oldValue.Person = null; }
if ($this.Account.Person !== $this) {
Domain.UserAccount.setPerson(value, $this);
}
}
}
static setInvitation = ($this, value) => {
var oldValue = $this.Invitation;
$this.Invitation = value;
if (value != null) {
if (oldValue != null && oldValue.Person != null) { oldValue.Person = null; }
if ($this.Invitation.Person !== $this) {
Domain.MemberInvitation.setPerson(value, $this);
}
}
}
static setEmergencyContact = ($this, value) => {
var oldValue = $this.EmergencyContact;
$this.EmergencyContact = value;
if (value != null) {
}
}
static setBankAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.BankAccounts == null) $this.BankAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BankAccounts.length > 0) {
                    Domain.Person.removeBankAccounts($this, $this.BankAccounts[0]);
                }

                Domain.Person.addManyBankAccounts($this, copyItems);
            }
static addManyBankAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addBankAccounts($this, items[i]);
                }
            }
static addBankAccounts = ($this, item) => {
                if ($this.BankAccounts == null) $this.BankAccounts = [];
                if (item == null || $this.BankAccounts.indexOf(item) > -1) return;
                $this.BankAccounts.push(item);
if (item.Employee != $this) {
Domain.BankAccount.setEmployee(item, $this);
}
}
static addRangeBankAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addBankAccounts($this, item));
            }
static removeBankAccounts = ($this, item) => {
                if ($this == null || $this.BankAccounts == null || $this.BankAccounts.indexOf(item) === -1) return;
                var _index = $this.BankAccounts.indexOf(item);
                $this.BankAccounts.splice(_index, 1);
item.Employee = null;
}
static clearBankAccounts = ($this) => { $this.BankAccounts = null; }
static setPhoto = ($this, value) => {
var oldValue = $this.Photo;
$this.Photo = value;
if (value != null) {
}
}
static setCVFile = ($this, value) => {
var oldValue = $this.CVFile;
$this.CVFile = value;
if (value != null) {
}
}
static setLeaderOf = ($this, items) => {
                if (items == null) items = [];
                if ($this.LeaderOf == null) $this.LeaderOf = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LeaderOf.length > 0) {
                    Domain.Person.removeLeaderOf($this, $this.LeaderOf[0]);
                }

                Domain.Person.addManyLeaderOf($this, copyItems);
            }
static addManyLeaderOf = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addLeaderOf($this, items[i]);
                }
            }
static addLeaderOf = ($this, item) => {
                if ($this.LeaderOf == null) $this.LeaderOf = [];
                if (item == null || $this.LeaderOf.indexOf(item) > -1) return;
                $this.LeaderOf.push(item);
if (item.Leader != $this) {
Domain.Team.setLeader(item, $this);
}
}
static addRangeLeaderOf = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addLeaderOf($this, item));
            }
static removeLeaderOf = ($this, item) => {
                if ($this == null || $this.LeaderOf == null || $this.LeaderOf.indexOf(item) === -1) return;
                var _index = $this.LeaderOf.indexOf(item);
                $this.LeaderOf.splice(_index, 1);
item.Leader = null;
}
static clearLeaderOf = ($this) => { $this.LeaderOf = null; }
static setMemberOf = ($this, items) => {
                if (items == null) items = [];
                if ($this.MemberOf == null) $this.MemberOf = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MemberOf.length > 0) {
                    Domain.Person.removeMemberOf($this, $this.MemberOf[0]);
                }

                Domain.Person.addManyMemberOf($this, copyItems);
            }
static addManyMemberOf = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addMemberOf($this, items[i]);
                }
            }
static addMemberOf = ($this, item) => {
                if ($this.MemberOf == null) $this.MemberOf = [];
                if (item == null || $this.MemberOf.indexOf(item) > -1) return;
                $this.MemberOf.push(item);
Domain.Team.addMembers(item, $this);
}
static addRangeMemberOf = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addMemberOf($this, item));
            }
static removeMemberOf = ($this, item) => {
                if ($this == null || $this.MemberOf == null || $this.MemberOf.indexOf(item) === -1) return;
                var _index = $this.MemberOf.indexOf(item);
                $this.MemberOf.splice(_index, 1);
Domain.Team.removeMembers(item, $this);
}
static clearMemberOf = ($this) => { $this.MemberOf = null; }
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setTeamsCreated = ($this, items) => {
                if (items == null) items = [];
                if ($this.TeamsCreated == null) $this.TeamsCreated = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TeamsCreated.length > 0) {
                    Domain.Person.removeTeamsCreated($this, $this.TeamsCreated[0]);
                }

                Domain.Person.addManyTeamsCreated($this, copyItems);
            }
static addManyTeamsCreated = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addTeamsCreated($this, items[i]);
                }
            }
static addTeamsCreated = ($this, item) => {
                if ($this.TeamsCreated == null) $this.TeamsCreated = [];
                if (item == null || $this.TeamsCreated.indexOf(item) > -1) return;
                $this.TeamsCreated.push(item);
if (item.CreatedBy != $this) {
Domain.Team.setCreatedBy(item, $this);
}
}
static addRangeTeamsCreated = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addTeamsCreated($this, item));
            }
static removeTeamsCreated = ($this, item) => {
                if ($this == null || $this.TeamsCreated == null || $this.TeamsCreated.indexOf(item) === -1) return;
                var _index = $this.TeamsCreated.indexOf(item);
                $this.TeamsCreated.splice(_index, 1);
item.CreatedBy = null;
}
static clearTeamsCreated = ($this) => { $this.TeamsCreated = null; }
static setOrganisationAffiliations = ($this, items) => {
                if (items == null) items = [];
                if ($this.OrganisationAffiliations == null) $this.OrganisationAffiliations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OrganisationAffiliations.length > 0) {
                    Domain.Person.removeOrganisationAffiliations($this, $this.OrganisationAffiliations[0]);
                }

                Domain.Person.addManyOrganisationAffiliations($this, copyItems);
            }
static addManyOrganisationAffiliations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addOrganisationAffiliations($this, items[i]);
                }
            }
static addOrganisationAffiliations = ($this, item) => {
                if ($this.OrganisationAffiliations == null) $this.OrganisationAffiliations = [];
                if (item == null || $this.OrganisationAffiliations.indexOf(item) > -1) return;
                $this.OrganisationAffiliations.push(item);
if (item.AffiliatedPerson != $this) {
Domain.PersonOrgAffiliation.setAffiliatedPerson(item, $this);
}
}
static addRangeOrganisationAffiliations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addOrganisationAffiliations($this, item));
            }
static removeOrganisationAffiliations = ($this, item) => {
                if ($this == null || $this.OrganisationAffiliations == null || $this.OrganisationAffiliations.indexOf(item) === -1) return;
                var _index = $this.OrganisationAffiliations.indexOf(item);
                $this.OrganisationAffiliations.splice(_index, 1);
item.AffiliatedPerson = null;
}
static clearOrganisationAffiliations = ($this) => { $this.OrganisationAffiliations = null; }
static setCompetencies = ($this, items) => {
                if (items == null) items = [];
                if ($this.Competencies == null) $this.Competencies = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Competencies.length > 0) {
                    Domain.Person.removeCompetencies($this, $this.Competencies[0]);
                }

                Domain.Person.addManyCompetencies($this, copyItems);
            }
static addManyCompetencies = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Person.addCompetencies($this, items[i]);
                }
            }
static addCompetencies = ($this, item) => {
                if ($this.Competencies == null) $this.Competencies = [];
                if (item == null || $this.Competencies.indexOf(item) > -1) return;
                $this.Competencies.push(item);
}
static addRangeCompetencies = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Person.addCompetencies($this, item));
            }
static removeCompetencies = ($this, item) => {
                if ($this == null || $this.Competencies == null || $this.Competencies.indexOf(item) === -1) return;
                var _index = $this.Competencies.indexOf(item);
                $this.Competencies.splice(_index, 1);
}
static clearCompetencies = ($this) => { $this.Competencies = null; }

static GetCallNameOrFirst($this: any): any{return (CLMS.Framework.String.IsNullOrEmpty(($this?.CallName ?? '').trim()) ? $this?.FirstName : $this?.CallName);
}
static GetFullName($this: any): any{if ((CLMS.Framework.String.IsNullOrEmpty(($this?.FirstName ?? '').trim()) && CLMS.Framework.String.IsNullOrEmpty(($this?.LastName ?? '').trim()))) {return CLMS.Framework.String.Empty;}
if ((!(CLMS.Framework.String.IsNullOrEmpty(($this?.MiddleName ?? '').trim())))) {return $this?.FirstName + " " + $this?.MiddleName + " " + $this?.LastName;}
return $this?.FirstName + " " + $this?.LastName;
}
static GetHasAccount($this: any): any{return $this?.Account != null;
}
static GetMyLeaveBalances(person: any): any{return Joove.Common.cast(person?.EmploymentRelationships?.linq?.selectMany((a) => a?.LeaveBalances)?.toArray(), "System.Collections.List");
}
static GetOrgAffiliationsCaption($this: any): any{let orgs = $this?.OrganisationAffiliations?.linq?.select((a) => a?.AffiliatedOrg?.ShortName)?.toArray();
orgs?.addRange($this?.EmploymentRelationships?.linq?.select((a) => a?.Organisation?.ShortName)?.toArray());
orgs = orgs?.linq?.distinct()?.toArray();
if ((CLMS.Framework.Number.LessThanOrEqual(() => orgs.length, () => 0))) {return $this?.OrgAffiliationsCaption;}
return CLMS.Framework.String.Join(",", orgs);
}
static GetShortFullName($this: any): any{if ((CLMS.Framework.String.IsNullOrEmpty(($this?.FirstName ?? '').trim()) || CLMS.Framework.String.IsNullOrEmpty(($this?.LastName ?? '').trim()))) {return "";}
return $this?.FirstName?.substr(0, 1) + "." + $this?.LastName;
}
static IsWorkingDayForThem($this: any, date: any): any{let country = $this?.BasedInCountry;
let isWorkingDay = Domain.Country.IsDateBusinessDay(country, new Date(new Date(date)?.setHours(0, 0, 0, 0)));
if (!(isWorkingDay)) {return false;}
let ser = new CLMS.Framework.Utilities.Serializer<any>();
let daySearch = ser.ParseEnum(moment(date).day()?.toString());
let hasWorked = false;
let isWorkingOnSpecificDays = false;
for (let _iemp = 0; _iemp < ($this?.EmploymentRelationships == null ? 0 : $this?.EmploymentRelationships.length); _iemp++) {let emp = $this?.EmploymentRelationships[_iemp];let activeContract = Domain.Employee.GetActiveContractForDate(emp, date, "");if (CLMS.Framework.Number.GreaterThan(() => activeContract.ContractWorkDays.length, () => 0)) {isWorkingOnSpecificDays = true;let daysOfWeek = Joove.Common.cast(activeContract?.ContractWorkDays?.linq?.select((a) => a?.Day)?.toArray(), "System.Collections.List");if ((daysOfWeek?.linq?.contains(daySearch))) {hasWorked = true;}}}
return (isWorkingOnSpecificDays ? hasWorked : true);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}